import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-light" data-id="element-173">
      <div className="max-w-3xl mx-auto" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl border-2 border-gold-500/30 p-6 sm:p-10 text-center shadow-lg" data-id="element-175">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-176">
            <ShieldCheck className="text-gold-500" size={36} data-id="element-177" />
          </div>

          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-dark mb-3" data-id="element-178">
            Garantía de Satisfacción Total
          </h2>

          <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-6 max-w-xl mx-auto" data-id="element-179">
            Si dentro de los primeros{' '}
            <span className="font-bold text-dark" data-id="element-180">7 días</span> sentís que este
            sistema no es para vos, te devolvemos el 100% de tu dinero. Sin
            preguntas, sin vueltas.
          </p>

          <div className="space-y-3 text-left max-w-md mx-auto mb-6" data-id="element-181">
            {['Reembolso completo en 7 días', 'Sin preguntas ni condiciones', 'Proceso simple y rápido'].map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-182">
                <CheckCircle2 className="text-gold-500 shrink-0" size={18} data-id="element-183" />
                <span className="text-sm sm:text-base text-gray-700 font-medium" data-id="element-184">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-gray-500 italic" data-id="element-185">
            Tu inversión está protegida. El riesgo es cero.
          </p>
        </motion.div>
      </div>
    </section>;
};